import { useEffect } from "react";
import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import FAQs from "./Component/FAQs";
import CookiePolicy from "./Component/CookiePolicy";
import SizeGuide from "./Component/SizeGuide";
import CareGuide from "./Component/CareGuide";
import PaymentSecurity from "./Component/PaymentSecurity";
import Accessibility from "./Component/Accessibility";
import siteConfig from "./config/siteConfig";

function App() {
  useEffect(() => {
    document.title = `${siteConfig.displayName} — ${siteConfig.tagline}`;
    const description = document.querySelector('meta[name="description"]');
    if (description) description.setAttribute("content", siteConfig.description);
  }, []);

  return (
    <CartProvider>
      <Router
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/size-guide" element={<SizeGuide />} />
          <Route path="/care-guide" element={<CareGuide />} />
          <Route path="/payment-security" element={<PaymentSecurity />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
